import { TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';

import { useTabRoute } from '@/v5/@hooks/auth/login/useTabRoute';

import { TabHeader } from '@/v5/components/atoms/Tab/TabHeader';
import { LoginForm } from '@/v5/components/organisms/AuthForm/LoginForm';
import { RegisterForm } from '@/v5/components/organisms/AuthForm/RegisterForm';

import { AUTH_TABS, authTabPanelStyles, tabListStyles } from '@/constants';
import { NORMAL_LOGIN } from '@/v5/@constants/login';
import { homePath } from '@/v5/paths';

function AuthTabs() {
    const { loginAction } = useSelector((state) => state.login) || {
        NORMAL_LOGIN,
    };
    const location = useLocation();
    const isDisabled = loginAction?.includes('MFA');
    const isHomePath = location.pathname === homePath();

    const { tabIndex, handleTabsChange } = useTabRoute(AUTH_TABS);

    return (
        <Tabs
            isLazy
            colorScheme="messenger"
            variant="line"
            index={tabIndex}
            onChange={handleTabsChange}
            className="px-[1px]">
            <TabList sx={tabListStyles}>
                {AUTH_TABS?.map(({ tab: t, path }, i) => (
                    <TabHeader
                        isDisabled={isDisabled && i === 1}
                        key={`${t}-${i}`}
                        tab={t}
                        as={Link}
                        to={path}
                        className="hover:no-underline">
                        {t}
                    </TabHeader>
                ))}
            </TabList>
            <TabPanels sx={authTabPanelStyles}>
                <TabPanel>
                    {isHomePath && <LoginForm loginAction={loginAction} />}
                </TabPanel>
                <TabPanel>
                    <RegisterForm />
                </TabPanel>
            </TabPanels>
        </Tabs>
    );
}

export { AuthTabs };
